'use strict';

angular.module('app')
    .factory('AuthService',['$http',function($http){

        return {
            signin: function (a_data) {

                var req = {
                    method: 'POST',
                    url: '/api/login',
                    dataType: 'json',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With' : 'XMLHttpRequest'
                    },
                    data : a_data
                };
                return $http(req);
            },
            recovery: function (a_data) {

                var req = {
                    method: 'POST',
                    url: '/api/password-recovery',
                    dataType: 'json',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With' : 'XMLHttpRequest'
                    },
                    data : a_data
                };
                return $http(req);
            }
        }
    }]);
